import { createSlice } from "@reduxjs/toolkit";
import { getExchanges, modifyExchangeStatus } from "./Exchanges.thunk";
import { exchangeRowId } from "../../../utils/exchangeIdentity";

const initialState = {
  merchantId: null,
  exchanges: [],
  status: "idle",
  error: null,
  page: 1,
  pageSize: 5,
  totalRecords: 0,
};

const getActive = (exchangeStatus) => {
  return exchangeStatus === 'E';
};

const toggleStatus = (exchangeStatus) => {
  return exchangeStatus === 'E' ? 'D' : 'E';
};

export const exchangesSlice = createSlice({
  name: "exchanges",
  initialState,
  reducers: {
    setMerchantId: (state, action) => {
      state.merchantId = action.payload;
      state.exchanges = [];
      state.status = "idle";
      state.error = null;
      state.page = 1;
      state.pageSize = 5;
      state.totalRecords = 0;
    },
    resetExchanges: (state) => {
      state.merchantId = null;
      state.exchanges = [];
      state.status = "idle";
      state.error = null;
    },
    toggleLocalExchangeState: (state, action) => {
      const id = action.payload;
      state.exchanges = state.exchanges.map((e) =>
        e.id === id ? { ...e, active: !e.active, status: toggleStatus(e.status) } : e
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExchanges.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getExchanges.fulfilled, (state, action) => {
        const { exchanges, page, pageSize, totalRecords } = action.payload;
        state.exchanges = (exchanges || []).map((e) => ({
          catalogId: e.id ?? null,
          id: exchangeRowId({
            catalogId: e.id,
            exchangeID: e.exchangeID,
            category: e.category,
            exchangeName: e.exchangeName,
          }),
          icon: e.exchangeLogoURL || null,
          code: e.exchangeID || '',
          name: e.exchangeName || "-",
          category: e.category || 'exchanges',
          status: e.status,
          active: !!getActive(e.status),
        }));
        state.page = page || 1;
        state.pageSize = pageSize || 5;
        state.totalRecords = totalRecords || state.exchanges.length;
        state.status = "succeeded";
        state.error = null;
      })
      .addCase(getExchanges.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Error getting exchanges";
        state.exchanges = [];
      });

    builder
      .addCase(modifyExchangeStatus.pending, (state) => {
        // keep optimistic UI handling in component / action
      })
      .addCase(modifyExchangeStatus.fulfilled, (state, action) => {
        const { exchangeRowKey, newStatus } = action.payload;
        state.exchanges = state.exchanges.map((e) =>
          e.id === exchangeRowKey ? { ...e, active: getActive(newStatus), status: newStatus } : e
        );
      })
      .addCase(modifyExchangeStatus.rejected, (state, action) => {
        state.error = action.payload?.message || "Error modifying exchange";
      });
  },
});

export const { setMerchantId, resetExchanges, toggleLocalExchangeState } =
  exchangesSlice.actions;

export default exchangesSlice.reducer;
